import {
  LOCALIZATIONS_GET,
  LOCALIZATIONS_GET_SUCCESS,
  LOCALIZATIONS_GET_ERROR,
} from './type'

/**
 * @param {*} languageCode
 */
export const localizationsGetAction = languageCode => {
  return {
    type: LOCALIZATIONS_GET,
    payload: { languageCode },
  }
}

/**
 * @param {*} response
 */
export const localizationsGetSuccess = response => {
  return {
    type: LOCALIZATIONS_GET_SUCCESS,
    payload: { response },
  }
}

/**
 */
export const localizationsGetError = () => {
  return {
    type: LOCALIZATIONS_GET_ERROR,
  }
}
